import React from "react";
import SectionHeader from "../SectionHeader";

const INDUSTRIES = [
  { name: "Manufacturing", icon: "⚙️" },
  { name: "Retail & POS", icon: "🛍️" },
  { name: "Logistics", icon: "🚚" },
  { name: "Healthcare", icon: "🏥" },
  { name: "Education", icon: "🎓" },
  { name: "Services", icon: "🧰" },
];

const IndustriesSection = () => (
  <section className="section section--muted">
    <SectionHeader
      eyebrow="Who it's for"
      title="Built for the industries we know"
    />
    <div className="industries-grid industries-grid--six">
      {INDUSTRIES.map((i) => (
        <div key={i.name} className="industry-card">
          <span className="industry-card__icon" aria-hidden>{i.icon}</span>
          <span className="industry-card__name">{i.name}</span>
        </div>
      ))}
    </div>
  </section>
);

export default IndustriesSection;
